import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { DropTarget as dropTarget } from 'react-dnd'

import { gridCreateDateDeals, gridRemoveDate } from 'actions/grid'
import { GRID_DND_SIDEBAR_SELLABLE_ITEM } from 'constants/grid-constants'

import GridLeftHeaderDate from './grid-left-header-date'

class GridLeftHeaderDateContainer extends Component {

  constructor(props) {
    super(props)

    this.onRemove = this.onRemove.bind(this)
  }

  onRemove() {
    this.props.gridRemoveDate(this.props.date.id)
  }

  render() {
    const { connectDropTarget } = this.props

    return connectDropTarget(
      <div>
        <GridLeftHeaderDate {...this.props} onRemove={this.onRemove} />
      </div>
    )
  }
}

GridLeftHeaderDateContainer.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  date: PropTypes.object.isRequired,
  gridCreateDateDeals: PropTypes.func.isRequired,
  gridRemoveDate: PropTypes.func.isRequired,
}

const gridLeftHeaderDateTarget = {
  drop(props, monitor) {
    const item = monitor.getItem()
    props.gridCreateDateDeals(props.date.id, item.sellableItem.id)
  },
}

const collect = (targetConnect, monitor) => {
  const isOver = monitor.isOver()
  return {
    isOver,
    connectDropTarget: targetConnect.dropTarget(),
    color: isOver ? monitor.getItem().sellableItem.color : null,
    canDrop: monitor.canDrop(),
  }
}

const mapDispatchToProps = { gridCreateDateDeals, gridRemoveDate }

const DNDGridLeftHeaderDate = dropTarget(
  GRID_DND_SIDEBAR_SELLABLE_ITEM,
  gridLeftHeaderDateTarget,
  collect
)(GridLeftHeaderDateContainer)

export default connect(undefined, mapDispatchToProps)(DNDGridLeftHeaderDate)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-left-header-date/grid-left-header-date-container.js
 **/